import { Injectable } from '@angular/core';
import { PackWizardStore } from './pack-wizard.store';
import { PackWizard, packWizardFactory } from './pack-wizard.model';
import { PackWizardQuery } from './pack-wizard.query';
import { ServiceWizardService } from '../service-wizard/service-wizard.service';

@Injectable({ providedIn: 'root' })
export class PacksWizardService {
    constructor(
        public packsWizardStore: PackWizardStore,
        private serviceWizardService: ServiceWizardService
    ) {}

    setPacksByApi(params) {
        if(!params || params.length === 0) {
            this.packsWizardStore.set([]);
            return;
        }

        this.resetStore();

        const packs: PackWizard[] = [];
        params.forEach( (param, index) => {
            packs.push(
                packWizardFactory(param, index)
            );
        });

        this.packsWizardStore.set({...packs});

        // Array with IDs that should be displayed
        const showServices = packs.filter( pack => !pack.joinCitation)
            .flatMap( pack => pack.serviceIDs);

        // Array with IDs that should be hidden
        const hiddeServices = packs.filter( pack => pack.joinCitation)
            .flatMap( pack => pack.serviceIDs)
            // If the same ID is in both arrays (showServices & hiddeServices), we will not hidde that service
            .filter( id => showServices.indexOf(id) === -1)


        hiddeServices.forEach( id => {
            this.serviceWizardService.hiddeService(id, true);
        })

    }

    toggleChecked(pack: PackWizard) {
        const isChecked = !pack.isChecked;
        this.packsWizardStore.update(pack.id, { isChecked: isChecked });
    }

    resetStore() {
        this.packsWizardStore.reset();
    }
}
